import { Link } from "react-router-dom";
import { nailists } from "../../../mocks/nailists";

export default function NailistSection() {
  return (
    <section className="py-24 bg-[#FAF8F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            Our Nailists
          </p>
          <h4 id="nailists" className="text-3xl text-[#3D2E2A] mb-4" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 400 }}>
            <a href="#nailists">担当ネイリスト</a>
          </h4>
          <p className="text-[#8B7355] text-sm max-w-xl mx-auto" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            経験豊富な専属ネイリストがお客様のご要望を丁寧にお聞きし、理想の指先を実現いたします
          </p>
        </div>

        {/* Nailist Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {nailists.map((nailist) => (
            <div
              key={nailist.id}
              className="bg-white rounded-2xl overflow-hidden border border-[#EDE7DF] hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={nailist.image}
                  alt={nailist.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="text-[#3D2E2A] text-xl mb-0.5" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 500 }}>
                    {nailist.name}
                  </h3>
                  <p className="text-[#B8956A] text-xs tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    ネイル歴{nailist.years}年 ／ {nailist.specialty}
                  </p>
                </div>
                <p className="text-[#6B5548] text-xs leading-relaxed mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {nailist.description}
                </p>
                <Link
                  to={`/booking?nailist=${nailist.id}`}
                  className="w-full flex items-center justify-center gap-2 bg-[#B8956A] text-white py-3 rounded-full text-xs font-medium tracking-widest hover:bg-[#A07B55] transition-colors cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-heart-line text-sm" /></span>
                  {nailist.name.split(" ")[0]}を指名して予約
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* No Preference Button */}
        <div className="text-center">
          <p className="text-[#8B7355] text-sm mb-5" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            担当ネイリストをご指定されない場合はこちら
          </p>
          <Link
            to="/booking"
            className="inline-flex items-center gap-3 border-2 border-[#3D2E2A] text-[#3D2E2A] px-12 py-4 rounded-full text-sm font-medium tracking-widest hover:bg-[#3D2E2A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line text-sm" /></span>
            指名なしで予約する
          </Link>
        </div>
      </div>
    </section>
  );
}
